import ListFeaturePage from '@/common/components/list-route/ListFeaturePage.tsx';
import { getColumns } from '@/features/finance/sales-orders/columns.tsx';
import { SalesOrderFilterBarMain } from '@/features/finance/sales-orders/components/SalesOrderFilterBar.tsx';
import SalesOrderPagination from '@/features/finance/sales-orders/components/SalesOrderPagination.tsx';
import SalesOrderReportSidebar from '@/features/finance/sales-orders/components/SalesOrderReportSidebar.tsx';
import useSalesOrderQueryFromAtom from '@/features/finance/sales-orders/hooks/useSalesOrderQueryFromAtom.tsx';
import { salesOrderSortAtom } from '@/features/finance/sales-orders/sorting.ts';
import { SALES_ORDER_SORT_COLUMNS } from '@pac/filter/shared/sales-orders';
import { createFileRoute } from '@tanstack/react-router';
import { useMemo } from 'react';

export const Route = createFileRoute('/finance/sales-orders/')({
  component: RouteComponent,
  staticData: {
    authorization: {
      permission: {
        salesOrder: ['read'],
      },
    },
  },
});

function RouteComponent() {
  const query = useSalesOrderQueryFromAtom();
  const columns = useMemo(() => getColumns(), []);

  return (
    <ListFeaturePage
      analyticsSurface="sales_orders"
      storageKey="filter-aside:sales-orders"
      query={query}
      columns={columns}
      FilterBar={SalesOrderFilterBarMain}
      Pagination={SalesOrderPagination}
      ReportSidebar={SalesOrderReportSidebar}
      sortColumns={SALES_ORDER_SORT_COLUMNS}
      sortAtom={salesOrderSortAtom.sortAtom}
    />
  );
}
